var _circle, _circle2, _line, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoutesOneWay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#9AACCF",
    fill: "#9AACCF",
    viewBox: "0 0 33 37.5",
    height: 37.5,
    width: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.55895,
    cy: 6.3711,
    r: 4.14474,
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.21711,
    cy: 29.8581,
    r: 4.14474,
    stroke: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.21711,
    y1: 27.8581,
    x2: 23.55895,
    y2: 8.3711,
    fill: "none",
    strokeWidth: 1.84211,
    markerEnd: "url(#arrowEnd)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,17 L22,10 L16,14 Z",
    strokeWidth: 1.84211
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesOneWay);
export default __webpack_public_path__ + "static/media/routesOneWay.c07b95cb.svg";
export { ForwardRef as ReactComponent };